import {
	whiteColor,
	backgroundColor,
	dangerColor,
	successColor,
	warningColor,
	blackColors,
} from 'assets/jss/material-dashboard-pro-react';

const servicesTableCellsStyle = () => ({
	cell: ({ minHeight }) => ({
		textAlign: 'center',
		padding: '8px 5px',
		minHeight: minHeight ? `${minHeight}px` : 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	}),
	discountCell: {
		borderRadius: 2,
		border: `solid 1px ${warningColor[0]}`,
		padding: '0px 2px',
		textTransform: 'uppercase',
	},
	whiteColor: {
		backgroundColor: whiteColor,
	},
	backgroundGrayColor: {
		backgroundColor: backgroundColor[0],
	},
	checkCellSuccess: {
		'& svg': {
			color: successColor[0],
		},
	},
	checkCellFailure: {
		'& svg': {
			color: dangerColor[0],
		},
	},
	linearProgress: {
		maxWidth: 100,
		margin: '0 auto',
		marginBottom: 4,
		height: 4,
		'& > div': {
			height: 4,
		},
	},
	textCell: {
		minHeight: 65,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
	},
	dividedCell: {
		display: 'flex',
		marginBottom: 2,
		'& > div': {
			flex: 1,
			borderLeft: `1px solid ${blackColors[5]}`,
		},
		'& > div:first-child': {
			borderLeft: 'none',
		},
	},
});

export default servicesTableCellsStyle;
